module.exports = __webpack_public_path__ + "static/media/Img_4.87d13118.JPG";